export default "__VITE_ASSET__BHS8hbxO__"